import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
`;

export const SkeletonContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.space['2xl']} ${theme.space.md}`};
`;

export const SkeletonTitle = styled.div`
  width: 220px;
  height: 28px;
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme }) => theme.colors.background.secondary};
  margin: 0 auto ${({ theme }) => theme.space.lg};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const SkeletonTrack = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space.md};
  overflow: hidden;
`;

export const SkeletonCard = styled.div`
  flex: 0 0 calc((100% - 3 * 16px) / 4);

  @media (max-width: 1024px) {
    flex: 0 0 calc((100% - 2 * 16px) / 3);
  }

  @media (max-width: 640px) {
    flex: 0 0 calc((100% - 16px) / 2.25);
  }
`;

export const SkeletonImage = styled.div`
  width: 100%;
  aspect-ratio: 3 / 4;
  border-radius: ${({ theme }) => theme.radius.regular};
  background: ${({ theme }) => theme.colors.background.secondary};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const SkeletonText = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width ?? '80%'};
  height: 14px;
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme }) => theme.colors.background.secondary};
  margin: ${({ theme }) => theme.space.sm} auto 0;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;
